(function () {
  'use strict';

  if (window.__nestPdpVerifiedBuyer20260826) return;
  if (!/^\/products\//.test(window.location.pathname)) return;
  window.__nestPdpVerifiedBuyer20260826 = 'v2-observed-yotpo-source';

  var APP_KEY = 'CS0wMN7hGtPxBSzpvTmm6IvuWBGlgbXyH5OJYZ2x';
  var verifiedReviewIds = Object.create(null);
  var requestedSources = Object.create(null);
  var yotpoRequestPattern = /(?:api-cdn|api)\.yotpo\.com\//i;
  var productReviewsPattern = /\/products\/[^/]+\/reviews\.json$/i;
  var diagnostics = window.__nestPdpVerifiedBuyerDiagnostics = {
    capturedReviews: 0,
    verifiedReviews: 0,
    sources: []
  };

  function verified(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function isVerifiedReview(review) {
    var user = review && review.user;
    return verified(review && review.verified_buyer) ||
      verified(user && user.verified_buyer) ||
      /^verified buyer$/i.test(String(user && user.user_type || '').trim());
  }

  function reviewLists(payload) {
    var lists = [];
    var response = payload && payload.response;

    [payload, response].forEach(function (source) {
      if (!source) return;
      if (Array.isArray(source.reviews)) lists.push(source.reviews);
      if (Array.isArray(source.results)) lists.push(source.results);
    });

    return lists;
  }

  function remember(payload) {
    var changed = false;

    reviewLists(payload).forEach(function (reviews) {
      diagnostics.capturedReviews += reviews.length;
      reviews.forEach(function (review) {
        if (!review || review.id == null || !isVerifiedReview(review)) return;
        verifiedReviewIds[String(review.id)] = true;
        changed = true;
      });
    });

    diagnostics.verifiedReviews = Object.keys(verifiedReviewIds).length;
    if (changed) enhance(document);
  }

  function badge() {
    var element = document.createElement('div');
    element.className = 'nest-pdp-verified-buyer';
    element.innerHTML = '<span aria-hidden="true">&#10003;</span><span>Verified Buyer</span>';
    return element;
  }

  function reviewCards(root) {
    var cards = [];
    if (!root || !root.querySelectorAll) return cards;
    if (root.matches && root.matches('.product-reviews-api .reviews-grid [data-review-id]')) cards.push(root);
    return cards.concat(Array.prototype.slice.call(root.querySelectorAll('.product-reviews-api .reviews-grid [data-review-id]')));
  }

  function enhance(root) {
    reviewCards(root).forEach(function (card) {
      var reviewId = card.getAttribute('data-review-id');
      if (!verifiedReviewIds[reviewId] || card.querySelector('.nest-pdp-verified-buyer')) return;

      var customerName = card.querySelector('.nest-review-customer-name');
      var authorStack = card.querySelector('.nest-review-author-stack');
      if (customerName && customerName.parentNode) {
        customerName.parentNode.insertBefore(badge(), customerName.nextSibling);
      } else if (authorStack) {
        authorStack.appendChild(badge());
      }
    });
  }

  function installStyles() {
    if (document.getElementById('nest-pdp-verified-buyer-style-20260826')) return;
    var style = document.createElement('style');
    style.id = 'nest-pdp-verified-buyer-style-20260826';
    style.textContent = [
      '.product-reviews-api .nest-pdp-verified-buyer{align-items:center;color:#384F3B;display:inline-flex;font-family:"Noto Sans JP",sans-serif;font-size:13px;font-weight:700;gap:6px;letter-spacing:0;line-height:1.35;margin-top:5px;white-space:nowrap}',
      '.product-reviews-api .nest-pdp-verified-buyer>span:first-child{align-items:center;border:1px solid #384F3B;border-radius:50%;box-sizing:border-box;display:inline-flex;font-size:10px;height:17px;justify-content:center;width:17px}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function sourceKey(url) {
    try {
      var parsed = new URL(url, window.location.href);
      return parsed.origin + parsed.pathname;
    } catch (error) {
      return String(url || '');
    }
  }

  function requestReviews(url) {
    var key = sourceKey(url);
    if (!url || requestedSources[key]) return false;
    requestedSources[key] = true;
    diagnostics.sources.push(key);

    var parsed;
    try {
      parsed = new URL(url, window.location.href);
      parsed.searchParams.set('page', '1');
      parsed.searchParams.set('per_page', '150');
      parsed.searchParams.set('sort', 'rating');
      parsed.searchParams.set('direction', 'desc');
      parsed.searchParams.delete('callback');
    } catch (error) {
      return false;
    }

    window.fetch(parsed.toString(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Verified review request failed');
        return response.json();
      })
      .then(remember)
      .catch(function () {});
    return true;
  }

  function hydrateFromObservedRequests() {
    if (!window.performance || !window.performance.getEntriesByType) return false;
    var found = false;
    window.performance.getEntriesByType('resource').forEach(function (entry) {
      var parsed;
      try { parsed = new URL(entry.name); } catch (error) { return; }
      if (!yotpoRequestPattern.test(parsed.href) || !productReviewsPattern.test(parsed.pathname)) return;
      found = requestReviews(parsed.href) || found;
    });
    return found;
  }

  function hydrateFallback() {
    var root = document.querySelector('.product-reviews-api[data-product-id]');
    if (!root) return;
    var productId = root.getAttribute('data-product-id');
    if (!productId) return;
    requestReviews('https://api-cdn.yotpo.com/v1/widget/' + APP_KEY + '/products/' + encodeURIComponent(productId) + '/reviews.json');
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url;
      var request = nativeFetch.call(this, input, init);

      if (yotpoRequestPattern.test(String(requestUrl || ''))) {
        request.then(function (response) {
          response.clone().json().then(remember).catch(function () {});
        }).catch(function () {});
      }

      return request;
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype.open) {
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      if (yotpoRequestPattern.test(String(url || ''))) {
        this.addEventListener('load', function () {
          try {
            remember(this.responseType === 'json' && this.response ? this.response : JSON.parse(this.responseText));
          } catch (error) {}
        });
      }
      return nativeOpen.apply(this, arguments);
    };
  }

  installStyles();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) enhance(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function start() {
    enhance(document);
    [250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(hydrateFromObservedRequests, delay);
    });
    window.setTimeout(function () {
      if (!diagnostics.sources.length) hydrateFallback();
    }, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
